// extracted by mini-css-extract-plugin
module.exports = {"title":"otp-card_title__wtOdY","sub-title":"otp-card_sub-title__a_j9F","input":"otp-card_input__FBCOG","info":"otp-card_info__OqGKe","footer":"otp-card_footer__sjlS4"};